import { isCancel } from 'axios';
import config from '../config/raven';
import Raven from '../../app/utils/raven';
import getEnvironmentFromInstitutionUrl from './getEnvironmentFromInstitutionUrl';

let environment = {};
if (window && window.location && window.location.href) {
  environment = {
    environment: getEnvironmentFromInstitutionUrl(window.location.href),
  };
}

const errorCanBeIgnored = (error) => {
  if (!error || !error.message) {
    return false;
  }
  if (isCancel(error)) {
    return true;
  }

  const { message } = error;
  if (message.includes('Not Found!')) {
    return true;
  }

  switch (message) {
    /** We are having a high number of network error and
     * this is eating away our sentry quota, so we're ignoring this for now.
     */
    case 'Network Error':
      return true;
    /** In theory this error should be caught by the `isCancel`
     * but since it has a high number I'm also adding this check
     * to avoid without a doubt that this sort of error is sent.
     */
    case 'Newer request.':
      return true;
    /**
     * When someone accesses a space they don't have permission to, this
     * error is thrown. No need to log to sentry, we can only improve
     * the UX - here's the issue for it: https://github.com/AulaEducation/aula/issues/9401
     */
    case 'You need to provide the classRoom':
      return true;
    /**
     * Mobile error, probably related to the navigation type used.
     * We're working on using a new dependency for the navigation
     * so we chose to ignore this error for now so we don't use all of our
     * sentry quota.
     */
    case 'Failed to execute stack command. Stack Component32 not found.':
      return true;
    default:
      return false;
  }
};

export const beforeSend = (event, hint) => {
  const originalError = hint.originalException;
  if (errorCanBeIgnored(originalError)) {
    return null;
  }

  return event;
};

const denyUrls = [
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
];

Raven.init({
  dsn: config.DSN,
  ...environment,
  beforeSend,
  denyUrls,
  // At the moment, web-app sends too many events to Sentry.
  // Reducing the sample rate will ensure we do not consume our quota
  // whilst ensuring we get a good enough sample to identify the
  // most common issues.
  sampleRate: 0.3,
});

export default Raven;
